import cx from 'classnames'
import { observer } from 'mobx-react-lite'
import { useContext } from 'react'
import { computed } from 'mobx'

import { ReactComponent as HighlightColorIcon } from 'assets/icons/highlightColor24.svg'
import { ActiveColorsIndicator } from 'common/Prose/components/ActiveColorsIndicator/ActiveColorsIndicator'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'
import { AlmanacEditorStateContext } from 'stores/EditorState'

import { TopTiers } from '../../Types'
import { useMobileToolbar } from '../../stores/MobileToolbarStore'

import MStyles from '../../MobileToolbar.module.scss'
import Styles from './HighlightColor.module.scss'

export const HighlightColor = observer((props: ButtonProps) => {
  const mobileToolbarStore = useMobileToolbar()
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { highlightColors: activeColors } = useContext(AlmanacEditorStateContext)!

  const isSelected = computed(() => mobileToolbarStore.topTier === TopTiers.HighlightColor).get()

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Change highlight color"
      data-testid={`color-highlight-trigger`}
      className={cx(MStyles.button, Styles.button, Styles.flexCenterColumn, {
        [MStyles.buttonSelected]: isSelected,
        [Styles.buttonSelected]: isSelected,
      })}
      {...props}
    >
      <HighlightColorIcon />
      <ActiveColorsIndicator colors={activeColors.slice(0, 4)} className={Styles.activeIndicator} />
    </Button>
  )
})
